module.exports = __webpack_public_path__ + "static/media/marketoProcess4.4cb2ffa0.png";